export const environment = {
  production: true,
  appRoot: "https://prod.fynka.burrusdevelopment.com",
  hostname: "preprod.fynka.burrusdevelopment.com",
  hostUrl:"https://fynka.burrusdevelopment.com",
  langUrl:"./assets/i18n/"
};
